/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
import Pagination from '@/components/pagination/index.vue';
import Servece from './servece.js';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs,
    Pagination
  },
  data() {
    return {
      color: '#fff',
      fromisActiveClass: 'mediaReports',
      reportArr: [],
      pageNum: 1,
      pageSize: 6,
      params: {
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '6188e64fc2d92675c94f559b',
        // homePage: 1, // 只要首页推荐且已发布的数据
        source: 'guanWang',
        status: 1,
        limit: 6,
        pageNum: 1,
        skip: 0
      },
      total: 0
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.getNewsList();
  },
  methods: {
    goHome() {
      this.$router.push({path: 'home'});
    },
    goMediaReportsDetail(paths, id) {
      this.$router.push({
        path: paths,
        query: {
          id: id
        }
      });
    },
    getNewsList(Pagination = {}) {
      if(Pagination.pageNo || Pagination.pageSize) {
        this.params.pageNum = Pagination.pageNo;
        this.params.limit = Pagination.pageSize;
      }
      let query = {
        ...this.params,
        skip: this.params.pageNum ?  (this.params.pageNum - 1) * this.params.limit : 0
      };
      Servece.getNewsList(query).then(data => {
        this.reportArr = data.data && data.data.list.slice(0, 6);
        this.total = data.data.total;
      });
    }
  }
};
